<script>
import { mapActions } from "vuex";
import topNav from "../../package/topNav.vue";
import propertySelection from "../propertySelection.vue";
import ContactBannerDark from "../../package/contactBannerDark.vue";
import advertisementSection from "../advertisementSection.vue";
// import MobileAppDownload from "../../package/mobileAppDownload.vue";
// import agentSignInBox from "../../package/agentSignInBox.vue";
import footNav from "../../package/footer.vue";

export default {
  name: "uConnectSelectionLayout",
  data() {
    return {
      adPage: "Property Reservation",
      adSuburbs: "",
      adsData: "",
      showFootTxt: true,
      gray: false
    };
  },
  beforeUpdate() {
    document.title =
      "UNIFI Property: Select Property (" + this.$route.query.pid + ")";
  },
  components: {
    topNav,
    propertySelection,
    ContactBannerDark,
    advertisementSection,
    // MobileAppDownload,
    // agentSignInBox,
    footNav
  },
  methods: {
    ...mapActions("advertisement", ["getAdvertisements"]),
    getAdsbyPageAndSuburb() {
      let body_params = {
        adPage: this.adPage,
        adSuburbs: this.adSuburbs
      };
      console.log("getAdsbyPageAndSuburb", body_params);
      this.getAdvertisements({
        params: body_params,
        callback: this.getAdvertisementsCallback
      });
    },
    getAdvertisementsCallback(resp) {
      console.log("getAdvertisementsCallback: ", resp);
      if (resp.code == 0) {
        this.adsData = resp.data;
      } else {
      }
    }
  },
  mounted() {
    // this.getAdsbyPageAndSuburb();
  }
};
</script>

<template>
  <el-container :lg="3" :md="4" :sm="6" :xl="1" :xs="8" class="mainWrapper">
    <el-header style="padding: 0">
      <top-nav v-bind:gray="gray"></top-nav>
    </el-header>
    <el-main style="padding: 0; overflow: visible; margin-top: 40px">
      <property-selection />
<!--      <contact-banner-dark />-->
<!--      <advertisement-section-->
<!--        id="propertyReservation1stPage"-->
<!--        :adLink="adsData.propertyReservation1Click"-->
<!--        :adUrl="adsData.propertyReservation1"-->
<!--      />-->
<!--      <mobile-app-download/>-->
    </el-main>
    <el-footer style="padding: 0">
<!--      <agent-sign-in-box />-->
      <foot-nav :showQus="showFootTxt"></foot-nav>
    </el-footer>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #ffffff;
  max-width: 1920px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/uConnectReservation/selection/selectionLayout.vue